<p *ngIf="!faqsInDatabase" [innerHtml]="'FAQ_TEXT' | translate"></p>

<div *ngIf="faqsInDatabase">
  <div
    *ngFor="let faq of _portalConfigurationService.faqs | filterFaqsByLanguage:_resourceService?.language">
    <p><strong>
        {{ faq.question }}
      </strong> <br>
      {{ faq.answer }}</p>
    <br />
    <br />
  </div>
</div>